export default class ComposePoints
{
    constructor(modules = null)
    {
        this.isUsingPoints   = false;
        this.isUsingAutoFail = false;

        if (typeof modules === 'object' && modules !== null)
        {
            if ('points' in modules)
            {
                this.isUsingPoints = modules['points'] ? true : false;
            }
            if ('autoFail' in modules)
            {
                this.isUsingAutoFail = modules['autoFail'] ? true : false;
            }
        }

        this.showPoints();

        // click on a questions mb-4 input
        $('form').on('change', '.questions > .mb-4 > .form-check.radio > input', (e) => {
            this.clickRadioResponse(e);
        });
        $('form').on('change', '.questions > .mb-4 > .form-check.checkbox > input', (e) => {
            this.clickCheckboxResponse(e);
        });
        $('form').on('keyup', '.questions > .mb-4 > input[type="text"]', (e) => {
            this.keyUpTextResponse(e);
        });
        $('form').on('keyup', '.questions > .mb-4 > textarea', (e) => {
            this.keyUpTextareaResponse(e);
        });
    }

    /**
     * showPoints
     *
     * If this form is configured to show points, will show the point value for questions response.
     *
     * @return null
     */
    showPoints()
    {
        if ($('#show_points').val() == 1)
        {
            $('.form-check').each(function() {
                let $chk = $(this);
                let pts  = $chk.find('input').attr('data-points');

                let span = document.createElement('span');
                span.textContent = pts;
                $chk.find('> label').addClass('has-points').append(span);
            });
        }
    }

    /**
     * clickRadioResponse
     *
     * When a user clicks a radio input, calculate the points and scores
     *
     * @param {Object} event
     * @return null
     */
    clickRadioResponse(event)
    {
        let $input           = $(event.currentTarget);
        let responsePoints   = $input.attr('data-points');
        let responseAutoFail = $input.attr('data-fail');
        let responseNa       = $input.attr('data-na');
        let sectionIndex     = $input.attr('data-section');
        let questionIndex    = $input.attr('data-question');
        let responseIndex    = $input.attr('data-response');

        // Auto Fail
        this.handleResponseAutoFail(sectionIndex, questionIndex, responseAutoFail);

        // Points
        if (this.isUsingPoints) {
            // This response is not applicable, delete any current points
            if (responseNa == 1) {
                delete(pointsConfig[sectionIndex][questionIndex]['currentPoints']);
            }

            // Save the current points for this questions response
            if (responseNa == 0) {
                pointsConfig[sectionIndex][questionIndex]['currentPoints'] = parseInt(responsePoints);
            }

            this.updatePointsAndScores();
        }
    }

    /**
     * clickCheckboxResponse
     *
     * When a user clicks a checkbox input, calculate the points and scores
     *
     * @param {Object} event
     * @return null
     */
    clickCheckboxResponse(event)
    {
        let $input           = $(event.currentTarget);
        let responsePoints   = $input.attr('data-points');
        let responseAutoFail = $input.attr('data-fail');
        let responseNa       = $input.attr('data-na');
        let sectionIndex     = $input.attr('data-section');
        let questionIndex    = $input.attr('data-question');
        let responseIndex    = $input.attr('data-response');

        // Auto Fail
        this.handleResponseAutoFail(sectionIndex, questionIndex, responseAutoFail);

        // Points
        if (this.isUsingPoints) {
            // This response is not applicable, delete any current points
            if (responseNa == 1) {
                delete(pointsConfig[sectionIndex][questionIndex]['currentPoints']);
            }

            // Save the current points for this questions response
            if (responseNa == 0) {
                if (pointsConfig[sectionIndex][questionIndex][responseIndex] === 0) {
                    if ('currentPoints' in pointsConfig[sectionIndex][questionIndex]) {
                        pointsConfig[sectionIndex][questionIndex]['currentPoints'] += parseInt(responsePoints);
                    } else {
                        pointsConfig[sectionIndex][questionIndex]['currentPoints'] = parseInt(responsePoints);
                    }
                    pointsConfig[sectionIndex][questionIndex][responseIndex] = 1;
                } else {
                    pointsConfig[sectionIndex][questionIndex]['currentPoints'] -= parseInt(responsePoints);
                    pointsConfig[sectionIndex][questionIndex][responseIndex] = 0;

                    // if removing this checkbox's points makes the currentPoints 0, then no checkboxes were checked
                    // and we should remove currentPoints and treat this as not answered
                    if (pointsConfig[sectionIndex][questionIndex]['currentPoints'] == 0)
                    {
                        delete(pointsConfig[sectionIndex][questionIndex]['currentPoints']);
                    }
                }
            }

            this.updatePointsAndScores();
        }
    }

    /**
     * keyUpTextResponse
     *
     * After entering text in a text box, will add the points.
     *
     * @param {Object} event
     * @return null
     */
    keyUpTextResponse(event)
    {
        let $input           = $(event.currentTarget);
        let responsePoints   = $input.attr('data-points');
        let responseAutoFail = $input.attr('data-fail');
        let responseNa       = $input.attr('data-na');
        let sectionIndex     = $input.attr('data-section');
        let questionIndex    = $input.attr('data-question');
        let responseIndex    = $input.attr('data-response');

        // Points
        if (this.isUsingPoints) {

            // This response is not applicable, delete any current points
            if (responseNa == 1) {
                delete(pointsConfig[sectionIndex][questionIndex]['currentPoints']);
            }

            if (responseNa == 0) {
                // If we have text, they get all the points
                if ($input.val().length) {
                    pointsConfig[sectionIndex][questionIndex]['currentPoints'] = parseInt(responsePoints);
                // if Text is empty, remove the points
                } else {
                    delete(pointsConfig[sectionIndex][questionIndex]['currentPoints']);
                }
            }

            this.updatePointsAndScores();
        }
    }

    /**
     * keyUpTextareaResponse
     *
     * After entering text in a text box, will add the points.
     *
     * @param {Object} event
     * @return null
     */
    keyUpTextareaResponse(event)
    {
        let $textarea        = $(event.currentTarget);
        let responsePoints   = $textarea.attr('data-points');
        let responseAutoFail = $textarea.attr('data-fail');
        let responseNa       = $textarea.attr('data-na');
        let sectionIndex     = $textarea.attr('data-section');
        let questionIndex    = $textarea.attr('data-question');
        let responseIndex    = $textarea.attr('data-response');

        // Points
        if (this.isUsingPoints) {

            // This response is not applicable, delete any current points
            if (responseNa == 1) {
                delete(pointsConfig[sectionIndex][questionIndex]['currentPoints']);
            }

            if (responseNa == 0) {
                // If we have text, they get all the points
                if ($textarea.val().length) {
                    pointsConfig[sectionIndex][questionIndex]['currentPoints'] = parseInt(responsePoints);
                // if Text is empty, remove the points
                } else {
                    delete(pointsConfig[sectionIndex][questionIndex]['currentPoints']);
                }
            }

            this.updatePointsAndScores();
        }
    }

    /**
     * handleResponseAutoFail
     *
     * Sets an questions as failed, so we can score then correctly later.
     *
     * @param int sectionIndex
     * @param int questionIndex
     * @param str responseAutoFail
     * @return null
     */
    handleResponseAutoFail(sectionIndex, questionIndex, responseAutoFail)
    {
        if (this.isUsingAutoFail) {
            // This response should fail the entire form
            if (responseAutoFail === 'form') {
                pointsConfig[sectionIndex][questionIndex]['fail'] = 'form';
            }

            // This response should fail the entire section
            if (responseAutoFail === 'section') {
                pointsConfig[sectionIndex][questionIndex]['fail'] = 'section';
            }

            // This response is not a auto fail
            if (responseAutoFail === 'none') {
                delete(pointsConfig[sectionIndex][questionIndex]['fail']);
            }
        }
    }

    /**
     * updatePointsAndScores 
     *
     * @return null
     */
    updatePointsAndScores()
    {
        let formTotalPoints = 0;
        let formPoints      = 0;
        let formFail        = false;

        // Get the section ids from the dom
        let $sectionIds = $('.form_section > a.anchor');

        if (this.isUsingAutoFail) {
            Object.keys(pointsConfig).forEach(s => {
                pointsConfig[s].forEach((question,  q) => {
                    if ('fail' in pointsConfig[s][q] && pointsConfig[s][q]['fail'] === 'form') {
                        formFail = true;
                    }
                });
            });
        }

        // Calculate the scores
        Object.keys(pointsConfig).forEach(sectionIndex => {
            let sectionTotalPoints = 0;
            let sectionPoints      = 0;
            let sectionId          = $sectionIds[sectionIndex].id;
            let sectionFail        = formFail ? true : false;

            pointsConfig[sectionIndex].forEach((question,  questionIndex) => {
                if ('currentPoints' in pointsConfig[sectionIndex][questionIndex]) {
                    let totalPoints   = pointsConfig[sectionIndex][questionIndex]['total'];
                    let currentPoints = pointsConfig[sectionIndex][questionIndex]['currentPoints'];

                    formTotalPoints    += totalPoints;
                    sectionTotalPoints += totalPoints;

                    if (this.isUsingAutoFail && 'fail' in pointsConfig[sectionIndex][questionIndex]) {
                        sectionFail = true;
                    }

                    if (!formFail && !sectionFail) {
                        sectionPoints += currentPoints;
                    }
                }
            });

            let sectionScore = 0;

            if (!sectionFail && sectionPoints > 0) {
                sectionScore = Math.round((sectionPoints / sectionTotalPoints) * 100);

                formPoints += sectionPoints;
            }

            // Update the section score
            $('#score-summary li.' + sectionId + ' > div > span').text(sectionScore + '%');
            $('#' + sectionId).next('h4').find('span.section-score').text(sectionScore + '%');
        });

        let formScore = 0;

        if (!formFail && formPoints > 0) {
            formScore = Math.round((formPoints / formTotalPoints) * 100);
        }

        // Update the total score
        $('#score-summary div.total > span').text(formScore+'%');

        $('#form-points').val(formPoints);
        $('#form-score').val(formScore);
    }
}
